"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSitemap = exports.fetchSitemaps = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var fetchSitemaps = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSitemaps,
  initiatingActionType: _actions.SitemapsActionTypes.LOAD_SITE_MAPS,
  requestStatusSelector: _selectors.getFetchSitemapsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSitemaps
}));
exports.fetchSitemaps = fetchSitemaps;
var updateSitemap = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateSitemap,
  initiatingActionType: _actions.SitemapsActionTypes.SAVE_SITE_MAP_CHANGES,
  requestStatusSelector: _selectors.getSaveSitemapChangesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.SaveSitemapChanges
}));
exports.updateSitemap = updateSitemap;